import { Injectable } from '@angular/core';
import { EventColor } from 'calendar-utils';

const colores: Record<string, EventColor> = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
  blue: {
    primary: '#D1E8FF',
    secondary: '#D1E8FF',
  },
  blue_strong: {
    primary: '#1773CD',
    secondary: '#1773CD',
  },
  blue_light: {
    primary: '#1E90FF',
    secondary: '#1E90FF',
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA',
  },
  purple: {
    primary: '#E0B0FF',
    secondary: '#E6CCEF',
  },
  purple_strong: {
    primary: '#BB6AEE',
    secondary: '#C191D2',
  },
  purple_light: {
    primary: '#DBAAFA',
    secondary: '#CDA2E8',
  },
  orange: {
    primary: '#ffb703',
    secondary: '#ff7f00',
  },
  cian: {
    primary: '#00ffff',
    secondary: '#19E5E6',
  },
  green: {
    primary: '#C7F1C2', //'#88bf76',
    secondary: '#C7F1C2', //'#88bf76',
  },
  green_strong: {
    primary: '#217e17',
    secondary: '#217e17',
  },
  green_light: {
    primary: '#559f46',
    secondary: '#559f46',
  },
  // para maderoterapia
  green_cake: {
    primary: '#d9ffd3',
    secondary: '#d9ffd3'
  },
  green_cake_medium: {
    primary: '#adffa0',
    secondary: '#adffa0'
  },
  green_cake_strong: {
    primary: '#97ff87',
    secondary: '#97ff87'
  }
};

export interface CalendarColors {
  backgroundColor: string;
  borderColor: string;
  textColor: string;
}

@Injectable({
  providedIn: 'root'
})
export class TemplatesNewCalendarService {
  constructor() { }
  
  getColorsPerType(type: number, assisted: number, event: any): CalendarColors {
    console.log('-- Type: ', type);
    if (assisted === 0) {
      return this.buildColorArray('red');
    }

    const currentNumberSession = Number(event.sessions.numberSession);
    console.log('-- Current number session: ', type);

    const paymentData = event.payments.filter((id: any) => Number(id.session_number) === currentNumberSession) || [];
    const resolver = this.packageResolver[type] || this.defaultPackage;

    return resolver.call(this, paymentData, event);
  }

  getTemplatesPerType(event: any, resume: boolean) {
    console.log('event: ', event);

    if (!event || !event.sessions) {
      return '';
    }
    
    if (event.sessions.numberSession === 0) {
      event.sessions.type_session = 0;
    }

    console.log('Type Session: ', event.sessions.type_session);

    if (event.sessions.numberSession === 0) {
      event.sessions.type_session = (event.sessions.name_valoration === 'Junta') ? 9 : 8;
    }
      
    const resolverTemplate = this.templateMapResolver[event.sessions.type_session] || this.defaultTemplatePackage;

    return resolverTemplate.call(this, event, resume);
  }

  private packageResolver: Record<number, (paymentData: any, event: any) => CalendarColors> = {
    1: this.defaultType,
    2: this.defaultType,
    3: this.packageType3,
    4: this.packageType4,
    5: this.packageType5,
    7: this.packageType7,
    12: this.defaultType,
    13: this.packageTypeMeetKt,
    14: this.packageTypeMeetKt
  };

  private templateMapResolver: Record<number, (event: any, resume: boolean) => string> = {
    1: this.templateDepilation,
    2: this.templateDepilation,
    3: this.templateDepilation,
    4: this.templateDepilation,
    5: this.templateDepilation,
    6: this.templateDepilation,
    7: this.templateDepilation,
    8: this.templateValoration,
    9: this.templateMeeting,
  };

  private defaultType(paymentData: any[], event: any): CalendarColors {
    const defaultColor = this.buildColorArray('blue');

    if (!this.isValidPaymentContext(paymentData, event)) {
      return defaultColor;
    }

    const payment = paymentData[0];
    const isCompleteAndPaid = this.isCompleteAndPaid(payment, event);

    return isCompleteAndPaid ? this.buildColorArray('green') : this.buildColorArray('purple');
  }

  private packageType3(paymentData: any[], event: any): CalendarColors {
    const defaultColor = this.buildColorArray('blue_strong');

    if (!this.isValidPaymentContext(paymentData, event)) {
      return defaultColor;
    }

    const payment = paymentData[0];
    const isCompleteAndPaid = this.isCompleteAndPaid(payment, event);

    return isCompleteAndPaid ? this.buildColorArray('green_strong') : this.buildColorArray('purple_strong');
  }

  private packageType4(paymentData: any[], event: any): CalendarColors {
    let defaultColor = this.buildColorArray('blue_light');

    if (!this.isValidPaymentContext(paymentData, event)) {
      return defaultColor;
    }

    const payment = paymentData[0];
    const isCompleteAndPaid = this.isCompleteAndPaid(payment, event);

    return isCompleteAndPaid ? this.buildColorArray('green_light') : this.buildColorArray('purple_light');
  }

  private packageType5(paymentData: any[], event: any): CalendarColors {
    let defaultColor = this.buildColorArray('cian');

    if (!this.isValidPaymentContext(paymentData, event)) {
      return defaultColor;
    }

    const payment = paymentData[0];
    const isCompleteAndPaid = this.isCompleteAndPaid(payment, event);

    return isCompleteAndPaid ? this.buildColorArray('green_strong') : this.buildColorArray('purple_strong');
  }

  private packageType7(paymentData: any[], event: any): CalendarColors {
    let defaultColor = this.buildColorArray('green_cake');

    if (!this.isValidPaymentContext(paymentData, event)) {
      return defaultColor;
    }

    const payment = paymentData[0];
    const isCompleteAndPaid = this.isCompleteAndPaid(payment, event);

    return isCompleteAndPaid ? this.buildColorArray('green_cake_strong') : this.buildColorArray('green_cake_medium');
  }

  private packageTypeMeetKt(paymentData: any[], event: any): CalendarColors {
    return this.buildColorArray('orange');
  }

  private templateDepilation(event: any, flag: boolean): string {
    console.log('filterTemplate: ', event);
    const paymentDone = event.payments.length !== 0 ? this.getPaymentPerSession(event) : '';
    const areas = this.getAreasAsString(event.areas);
    const typePackage = this.getTypePackageMap[event.sessions.type_session];
    const templateButtons: string = flag ? `<div>
            ${this.getTemplateButtons(event.sessions.id, event.sessions.dateStart, event.sessions.dateEnd)}
          </div>`: '';
    const comments: string = event.sessions.comments !== '' ? `<div>
            💬 ${event.sessions.comments}
          </div>` : '';
    console.log('-- Evento: ', event.sessions);
    const iconConfirmed = event.sessions?.confirmed === 0 ? '<i class="bi bi-x-circle text-danger"></i>' 
                                                          : '<i class="bi bi-check-circle-fill text-success"></i>';
    const secondConfirmed = this.getUserIcon(event.sessions.assisted);

    let contentHtml = `
        <div class="fc-custom-event">
          ${templateButtons}
          <div class="fc-title fs-5">
            🤩 - ${iconConfirmed} ${secondConfirmed} ${event.client.identifier} ${event.client.shared_names}
          </div>
          <div class="fc-description fs-6">
            📞 ${event.client.phone}
          </div>
          <div class="fc-time fs-6">
            ⏰ ${event.sessions.timeStart} - ${event.sessions.timeEnd}
          </div>
          <div class="mt-2 fw-bold fs-5" *>
            ${paymentDone}
          </div>
          <div class="mt-2 fw-bold fs-6">
            🏃‍➡️ ${typePackage} (${areas})
          </div>
          <div class="mt-2 fw-bold fs-5">
            ${comments}
          </div>
        </div>
      `;

    return contentHtml;
  }

  private templateValoration(event: any): string {
    console.log('-- Event: ', event);
    const comments: string = event.sessions.comments !== '' && event.sessions.comments !== ' - ' ? `<div>
            💬 ${event.sessions.comments}
          </div>` : '';
    const iconConfirmed = event.sessions?.confirmed === 0 ? '<i class="bi bi-x-circle text-danger"></i>' 
                                                          : '<i class="bi bi-check-circle-fill text-success"></i>';
    const secondConfirmed = this.getUserIcon(event.sessions.assisted);

    const contentHtml: string = `
      <div class="fc-custom-event">
        ${this.getDemoButtons(event.sessions.id, event.sessions.dateStart, event.sessions.dateEnd)}
        <div class="fc-title fs-5">
          🤩 - ${iconConfirmed} ${secondConfirmed} ${event.client.shared_names}
        </div>
        <div class="fc-description fs-6">
          📞 ${event.client.phone === "" ? 'N/A' : event.client.phone}
        </div>
        <div class="fc-time fs-6">
          ⏰ ${event.sessions.timeStart} - ${event.sessions.timeEnd}
        </div>
        <div class="mt-2 fw-bold fs-6">
          Sesión de Valoración
        </div>
        <div class="mt-2 fw-bold fs-5">
          ${comments}
        </div>
      </div>
    `;

    return contentHtml;
  }

  private templateMeeting(event: any): string {
    const comments = event.sessions.comments === '' && event.sessions.comments === ' - ' ? '' : `<div>
            💬 ${event.sessions.comments}
          </div>`;

    const contentHtml: string = `
      <div class="fc-custom-event">
        ${this.getDemoButtons(event.sessions.id, event.sessions.dateStart, event.sessions.dateEnd)}
        <div class="fc-title fw-bold fs-5">
          Junta
        </div>
        ${comments}
      </div>
    `;

    return contentHtml;
  }

  private getTemplateButtons(id: number, dateStart: string, dateEnd: string): string {
    let html = '<div class="fc-event-buttons">';
    console.log('Hola amigos');
    const html1 = `
      <button data-id="${id}" class="fc-action-btn btn-view btn-info">
        <i class="bi bi-folder2-open"></i>
      </button>
    `;
    const html2 = `
      <button data-id="${id}" data-start="${dateStart}" data-end="${dateEnd}" class="fc-action-btn btn-view btn-change-time">
        <i class="bi bi-pencil"></i>
      </button>
    `;

    const html3 = `
      <button data-id="${id}" class="fc-action-btn btn-view btn-comments-historical">
        <i class="bi bi-chat-dots ms-1"></i>
      </button>
    `;

    const html4 = `
      <button data-id="${id}" class="fc-action-btn btn-view btn-redirect-user">
        <i class="bi bi-file-earmark-person ms-1"></i>
      </button>
    `;

    html += html1 + html2 + html3 + html4 + '</div>';

    return html;
  }

  private getDemoButtons(id: number, dateStart: string, dateEnd: string): string {
    let html: string = '<div class="fc-event-buttons">';

    const html1: string = `
      <button data-id="${id}" class="fc-action-btn btn-view btn-info">
        <i class="bi bi-folder2-open"></i>
      </button>
    `;
    const html2: string = `<button data-id="${id}" data-start="${dateStart}" data-end="${dateEnd}" class="fc-action-btn btn-view btn-change-time">
        <i class="bi bi-pencil"></i>
      </button>`;

    html = html1 + html2 + '</div>';

    return html;
  }

  private getPaymentPerSession(event: any): string {
    console.log('EVENTO PAYMENTS: ', event);
    const filterPayment = event.payments.filter((pay: any) => {
      return Number(pay.session_number) === Number(event.sessions.numberSession);
    });
    
    if (filterPayment.length === 0) {
      return '';
    }
    
    const paymentsMessageDisplayed = filterPayment[0].is_paid 
            ? `${filterPayment[0].amount_payed == 0 ? new Intl.NumberFormat('es-MX', {
                  style: 'currency', currency: 'MXN' }).format(filterPayment[0].current_payment)
               : new Intl.NumberFormat('es-MX', {
                  style: 'currency', currency: 'MXN' }).format(filterPayment[0].amount_payed)} pagado` 
            : `${new Intl.NumberFormat('es-MX', {
                  style: 'currency', currency: 'MXN' }).format(filterPayment[0].payment_original)} a pagar`;

    return `💰 ${paymentsMessageDisplayed ?? 0}`;
  }

  private returnIsObject(data: any): boolean {
    return typeof data === 'object';
  }

  private getTypePackageMap: Record<number, string> = {
    1: 'Depilacion',
    2: 'Depilacion',
    4: 'Hidrafacial',
    5: 'Radiofrecuencia',
    6: 'Eterna Juventud',
    7: 'Maderoterapia / Metaloterapia',
  }

  private getAreasAsString(areas: any): string {
    console.log('-- areas: ', areas);
    const areasCompleted = areas
                  .map((area: any) => area.name)
                  .join(', ');
 
    return areasCompleted;
  }

  private isCompleteAndPaid(payment: any, event: any): boolean {
    return (payment?.is_paid && Number(payment?.payment_original) === 0
            && (event?.sessions?.complete_session || event?.sessions?.sessionClose));
  }

  private isValidPaymentContext(paymentData: any[], event: any): boolean {
    if (!this.returnIsObject(event.payments) || !paymentData.length) {
      return false;
    }

    const payment = paymentData[0];
    return (Number(payment.amount_payed) >= 0 || Number(payment.payment) >= 0);
  }

  private defaultPackage(): CalendarColors {
    return this.buildColorArray('blue_strong');
  }

  private defaultTemplatePackage(event: any, flag: boolean): string {
    const commentsVariable = (!event.sessions.comments || event.sessions.comments.trim() === '-') 
            ? '' : `💬 ${event.sessions.comments}`;

    return `
      <div class="fc-custom-event">
        <div class="fc-title fw-bold fs-5 text-white">
          🗓️ ${event.sessions.name_valoration}
        </div>
        <div class="fc-description fs-6 text-white mt-2">
          ${commentsVariable}
        </div>
      </div>
    `;
  }

  private buildColorArray(colorKey: string): CalendarColors {
    return {
      backgroundColor: colores[colorKey].secondary,
      borderColor: colores[colorKey].primary,
      textColor: "#000000"
    };
  }

  private getUserIcon(assited: number): string {
    let response: string = '';

    if (assited === 1) {
      response = '<i class="bi bi-person-check text-success"></i>';
    } else if (assited === 0) {
      response = '<i class="bi bi-person-x text-danger"></i>';
    } else {
      response = '<i class="bi bi-person-exclamation text-warning"></i>';
    }

    return response;
  }
}
